import React, { useEffect, useState, useRef } from 'react';
import loginDesign from '../../assets/images/loginDesign.svg';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import apiService from '../../services/apiservice';
import { APP_ROUTES } from '../../routes/approutes';
import { toast } from 'react-toastify';
import moment from 'moment';
import Backdrop from '@mui/material/Backdrop';
import {
    Button,
    Typography,
    Modal,
    CardHeader,
    IconButton,
    Divider,
    Box,
    CircularProgress,
} from '@mui/material';
import login1 from '../../assets/images/login1.png';
import login2 from '../../assets/images/login2.png';
import loginLogo from '../../assets/images/loginLogo.svg';
import CloseIcon from '@mui/icons-material/Close';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Sidebar } from 'primereact/sidebar';
import { encryptData } from '../../assets/encryptDecrypt';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
};

const LoginPage = () => {
    const navigate = useHistory();
    const [loginType, setLoginType] = useState('email');
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({
        userCode: '',
        passWord: '',
        userMobileNumber: '',
        userOTP: '',
        otpDigit1: '',
        otpDigit2: '',
        otpDigit3: '',
        otpDigit4: '',
        otpDigit5: '',
        otpDigit6: '',
    });
    const [loader, setLoader] = useState(false);
    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [showOtp, setShowOtp] = useState(false);
    const [showSubmitOtp, setShowSubmitOtp] = useState(false);
    const [seconds, setSeconds] = useState(60);
    const [resendDisabled, setResendDisabled] = useState(false);
    const [forget, setForget] = useState('');
    const [termsView, setTermsView] = useState(false);
    const [privacyView, setPrivacyView] = useState(false);
    const [termsAccept, setTermsAccept] = useState(false);
    const [policyAccept, setPolicyAccept] = useState(false);
    const [spDetails, setSpDetails] = useState();
    const [consentVersionT, setConsentVersionT] = useState();
    const [consentVersionP, setConsentVersionP] = useState();
    const [showConsentView, setShowConsentView] = useState(false);
    const [versionTextChanged, setVersionTextChanged] = useState(false);
    const [humanConfirmed, setHumanConfirmed] = useState(false);
    const [showCompliancePopup, setShowCompliancePopup] = useState(false);

    const intervalRef = useRef(null);
    const inputRefs = useRef(Array.from({ length: 6 }, () => React.createRef()));

    useEffect(() => {
        apiService.getUserConsent().then((result) => {
            const policy = result.data.data.find(val => val.constentName === "PrivacyPolicy");
            const terms = result.data.data.find(val => val.constentName === "TermsAndCondition");
            setConsentVersionP(policy);
            setConsentVersionT(terms);
        });
    }, []);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const startTimer = () => {
        setResendDisabled(true);
        setSeconds(60);
        intervalRef.current = setInterval(() => {
            setSeconds((prevSeconds) => {
                if (prevSeconds === 1) {
                    clearInterval(intervalRef.current);
                    setResendDisabled(false);
                }
                return prevSeconds - 1;
            });
        }, 1000);
    };

    const resetTimer = () => {
        clearInterval(intervalRef.current);
        setResendDisabled(false);
        setSeconds(60);
    };

    const handleResendOTP = async () => {};

    useEffect(() => {
        if (showOtp) {
            startTimer();
        } else {
            resetTimer();
        }
        return () => clearInterval(intervalRef.current);
    }, [showOtp]);

    const handleOTPChange = (index, value) => {
        const fieldName = `otpDigit${index + 1}`;
        setFormData(prev => ({ ...prev, [fieldName]: value }));
        if (value && index < inputRefs.current.length - 1) {
            inputRefs.current[index + 1].current.focus();
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace') {
            inputRefs.current[index].current.value = '';
            if (index > 0) inputRefs.current[index - 1].current.focus();
        } else if (e.key === 'ArrowLeft') {
            if (index > 0) inputRefs.current[index - 1].current.focus();
        } else if (e.key === 'ArrowRight') {
            if (index < inputRefs.current.length - 1) inputRefs.current[index + 1].current.focus();
        }
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        handleSubmit();
    };

    const handleSubmitClick = () => {
        onSubmitOTP();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleChangeforget = (e) => {
        setForget(e.target.value);
    };

    const getRoleFromUserRoles = (userRoles) => {
        if (userRoles?.some(obj => obj.roleCode === 'PRADMIN')) return 'PRADMIN';
        if (userRoles?.some(obj => obj.roleCode === 'GROUPPRADMIN')) return 'GROUPPRADMIN';
        if (userRoles?.some(obj => obj.roleCode === 'CE')) return 'CE';
        if (userRoles?.some(obj => obj.roleCode === 'ACCADMIN')) return 'ACCADMIN';
        return '';
    };

    const validateUserRole = (userRoles) => {
        const validRoles = new Set(['PRADMIN', 'GROUPPRADMIN', 'CE', 'ACCADMIN']);
        return userRoles?.some(obj => validRoles.has(obj.roleCode));
    };

    const checkConsentAndProceed = async (loginResponse, consentData) => {
        if (consentData?.message === "Data not found") {
            setShowConsentView(true);
            return false;
        }
        const userConsent = consentData?.data?.[0] || consentData?.[0];
        if (!userConsent) {
            setShowConsentView(true);
            return false;
        }
        const isPrivacyVersionChanged = userConsent.privacyVersionNumber !== consentVersionP?.versionNumber;
        const isTcVersionChanged = userConsent.tcVersionNumber !== consentVersionT?.versionNumber;
        const hasNoPrivacyConsent = userConsent.privacyPolicyConsent === 0;
        const hasNoTermsConsent = userConsent.termsAndConditionConsent === 0;
        if (isPrivacyVersionChanged || isTcVersionChanged || hasNoPrivacyConsent || hasNoTermsConsent) {
            if (isPrivacyVersionChanged || isTcVersionChanged) {
                setVersionTextChanged(true);
            }
            setShowConsentView(true);
            return false;
        }
        return true;
    };

    const loginToDashboard = async (loginResponse) => {
        const role = getRoleFromUserRoles(loginResponse.data?.user?.userRoles);
        localStorage.setItem('userSession', JSON.stringify(loginResponse.data?.userSession));
        localStorage.setItem('loginObj', JSON.stringify(loginResponse.data));
        localStorage.setItem('userRole', role);
        const userInfoResponse = await apiService.userInfo(loginResponse.data?.userSession?.userCode);
        if (userInfoResponse?.data.responseCode === '200') {
            localStorage.setItem('location', JSON.stringify(userInfoResponse?.data?.successObject));
        }
        if (role === 'PRADMIN') {
            navigate.push(APP_ROUTES.PRALIST);
        } else {
            navigate.push(APP_ROUTES.DASHBOARD);
        }
    };

    const handleSubmit = async () => {
        if (!humanConfirmed) {
            toast.error('Please confirm you are a human user by checking the checkbox');
            return;
        }
        if (!formData.userCode || !formData.passWord) {
            toast.error('Please enter credentials');
            return;
        }
        setLoader(true);
        setLoading(true);
        try {
            const payload1 = {
                userCode: formData.userCode,
                passWord: globalThis.btoa(formData.passWord),
                channel: 'W'
            };
            const encryptedData = encryptData(payload1);
            const url = `${process.env.REACT_APP_NEWHOSPITAL_BASEURL + 'authentication/gcp/token'}`;
            const response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(encryptedData),
            });
            if (!response.ok) throw new Error('Network response was not ok');
            const tokenResponse = await response.json();
            if (tokenResponse.responseCode !== '200') {
                toast.error(tokenResponse.responseMessage);
                setLoader(false);
                setLoading(false);
                return;
            }
            const access_token = tokenResponse.successObject?.access_token;
            localStorage.clear();
            localStorage.setItem('access_token', access_token);
            localStorage.setItem('access_name', formData.userCode.toUpperCase());
            localStorage.setItem('refresh_token', tokenResponse?.refresh_token);
            const updatedFormData = { ...formData, channel: 'W' };
            const loginResponse1 = await apiService.loginApi(JSON.stringify(updatedFormData));
            const loginResponse = { data: loginResponse1.data.successObject };
            if (!loginResponse?.data) {
                toast.error('Invalid User');
                setLoader(false);
                setLoading(false);
                return;
            }
            const isValidUser = validateUserRole(loginResponse.data?.user?.userRoles);
            if (!isValidUser) {
                toast.error('Invalid User');
                setLoader(false);
                setLoading(false);
                return;
            }
            setSpDetails(loginResponse);
            const consentResponse = await apiService.getApiCMS(loginResponse.data.user.code);
            const canProceed = await checkConsentAndProceed(loginResponse, consentResponse.data);
            if (canProceed) {
                await loginToDashboard(loginResponse);
            }
        } catch (error) {
            console.error('Error:', error);
            toast.error('Invalid login credentials');
        } finally {
            setLoader(false);
            setLoading(false);
        }
    };

    const onSubmitOTP = async () => {
        if (!humanConfirmed) {
            toast.error('Please confirm you are a human user by checking the checkbox');
            return;
        }
        setSubmitLoading(true);
        const otpDigits = ['otpDigit1', 'otpDigit2', 'otpDigit3', 'otpDigit4', 'otpDigit5', 'otpDigit6'];
        const allOTPDigitsEntered = otpDigits.every(digit => formData[digit]?.trim());
        if (!allOTPDigitsEntered) {
            toast.error('Please enter OTP');
            setSubmitLoading(false);
            return;
        }
        const fullOTP = otpDigits.map(digit => formData[digit]).join('');
        try {
            const tokenResponse = await apiService.getToken(formData, fullOTP);
            if (tokenResponse.status === 200 && tokenResponse?.data) {
                const access_token = tokenResponse.data.access_token;
                localStorage.clear();
                localStorage.setItem('access_token', access_token);
                localStorage.setItem('access_name', formData.userCode?.toUpperCase());
                localStorage.setItem('refresh_token', tokenResponse.data?.refresh_token);
            }
            const updatedFormData = {
                userMobileNumber: formData?.userMobileNumber,
                userOTP: fullOTP,
                channel: 'W',
            };
            const loginResponse = await apiService.loginUsingMobile(JSON.stringify(updatedFormData));
            if (loginResponse?.status === 200 && loginResponse?.data?.details?.[0]) {
                toast.error(loginResponse?.data?.details?.[0]);
                setSubmitLoading(false);
                return;
            }
            if (loginResponse?.data) {
                setSpDetails(loginResponse);
                const consentResponse = await apiService.getApiCMS(loginResponse.data.user.code);
                const canProceed = await checkConsentAndProceed(loginResponse, consentResponse.data);
                if (canProceed) {
                    await loginToDashboard(loginResponse);
                }
            }
        } catch (error) {
            console.error('API Error:', error);
            toast.error('Something went wrong');
        } finally {
            setSubmitLoading(false);
        }
    };

    const forgetPassword = async () => {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const mobileRegex = /^\d{10}$/;
        const numberRegex = /^\d+$/;
        if (!forget.trim()) {
            toast.error('Please Enter Email Or Mobile Number');
            return;
        }
        let payload = {};
        const input = forget.trim();
        if (numberRegex.test(input)) {
            if (!mobileRegex.test(input)) {
                toast.error('Please enter valid Mobile Number');
                return;
            }
            payload = { mobile: input };
        } else {
            if (!emailRegex.test(input)) {
                toast.error('Please enter valid Email ID');
                return;
            }
            payload = { email: input };
        }
        setLoader(true);
        try {
            const res = await apiService.forgetPassword(payload);
            if (!res.message) {
                toast.success("Reset password link has been sent to your registered Mobile Number and Email ID");
            } else if (res?.message === 'Validation Failed.') {
                toast.error('No user is available with this user id');
            } else {
                toast.error('Failed');
            }
        } catch (error) {
            console.error('API request error:', error);
        } finally {
            setLoader(false);
        }
    };

    const handleLoginTypeChange = (type) => {
        setLoginType(type);
        if (type === 'mobile') {
            setFormData({
                userCode: '',
                passWord: '',
                userMobileNumber: '',
                userOTP: '',
                otpDigit1: '',
                otpDigit2: '',
                otpDigit3: '',
                otpDigit4: '',
                otpDigit5: '',
                otpDigit6: '',
            });
        } else {
            setShowOtp(false);
            setShowSubmitOtp(false);
        }
    };

    const onConsentAgree = () => {
        if (!termsAccept) {
            toast.error('Please agree Terms of use');
            return;
        }
        if (!policyAccept) {
            toast.error('Please agree Privacy Policy');
            return;
        }
        const payload = {
            "createdBy": spDetails?.data?.user?.code,
            "createdDate": moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
            "modifiedBy": spDetails?.data?.user?.code,
            "modifiedDate": moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
            "privacyPolicyConsent": 1,
            "sourceChannel": "LB",
            "status": 1,
            "termsAndConditionConsent": 1,
            "type": "S",
            "userId": spDetails?.data?.user?.code,
            "privacyVersionNumber": consentVersionP?.versionNumber,
            "tcVersionNumber": consentVersionT?.versionNumber
        };
        setLoader(true);
        apiService.userConsentPost(payload).then((res) => {
            if (res.data === 1) {
                setShowConsentView(false);
                loginToDashboard(spDetails);
            }
            setLoader(false);
        }).catch(() => {
            setLoader(false);
        });
    };

    const handleComplianceUnderstand = () => {
        setShowCompliancePopup(false);
        setHumanConfirmed(true);
    };

    const renderConsentContent = () => {
        return (
            <div className="bg-white p-5">
                <p className="text-2xl font-semibold mb-8">
                    {versionTextChanged ?
                        <b>Privacy Policy and Terms and conditions have been changed please check again and give your consent.</b> :
                        <b>Please Accept Terms of use and Privacy Policy to continue</b>
                    }
                </p>
                <div className='mr-20'>
                    <div className="flex mt-4">
                        <div className="flex space-x-2">
                            <input
                                type="checkbox"
                                onChange={(e) => setTermsAccept(e.target.checked)}
                                className="form-radio"
                                name="accountType"
                                value="personal"
                                checked={termsAccept}
                            />
                            <div className="text-xs font-medium font-montserrat">
                                <button
                                    className="text-brand-primary font-medium text-sm cursor-pointer bg-transparent border-none p-0"
                                    onClick={() => setTermsView(true)}
                                >
                                    <u>Terms and conditions</u>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="flex mt-4">
                        <div className="flex space-x-2">
                            <input
                                type="checkbox"
                                onChange={(e) => setPolicyAccept(e.target.checked)}
                                className="form-radio"
                                name="accountType"
                                value="personal"
                                checked={policyAccept}
                            />
                            <div className="text-xs font-medium font-montserrat">
                                <button
                                    className="text-brand-primary font-medium text-sm cursor-pointer bg-transparent border-none p-0"
                                    onClick={() => setPrivacyView(true)}
                                >
                                    <u>Privacy policy</u>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const otpLength = 6;

    const renderOTPInputs = () => {
        return Array.from({ length: otpLength }).map((_, i) => (
            <input
                key={`otp-input-${i + 1}`}
                type="text"
                maxLength="1"
                className="otp-input"
                ref={(el) => (inputRefs.current[i] = el)}
                onChange={(e) => handleOTPChange(i, e.target.value)}
                onKeyDown={(e) => handleKeyDown(i, e)}
            />
        ));
    };

    return (
        <div className="flex bg-[#004172] text-[#004172] overflow-hidden h-screen">
            <Backdrop
                sx={{ color: "#FFFFFF", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loader}
            >
                <CircularProgress size={80} color="inherit" />
            </Backdrop>

            {showCompliancePopup && (
                <div
                    style={{
                        position: 'fixed',
                        inset: 0,
                        backgroundColor: 'rgba(0,0,0,0.6)',
                        zIndex: 9999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <div
                        style={{
                            backgroundColor: '#fff',
                            borderRadius: '12px',
                            width: '580px',
                            maxWidth: '95vw',
                            overflow: 'hidden',
                            boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: '#004172',
                                padding: '20px 24px',
                                display: 'flex',
                                alignItems: 'flex-start',
                                justifyContent: 'space-between',
                            }}
                        >
                            <div>
                                <h2 style={{ color: '#fff', fontSize: '20px', fontWeight: 700, margin: 0 }}>Disclaimer</h2>
                                <p style={{ color: '#cce0f5', fontSize: '13px', margin: '4px 0 0 0' }}>Please read before proceeding</p>
                            </div>
                            <button
                                onClick={() => setShowCompliancePopup(false)}
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    color: '#fff',
                                    fontSize: '20px',
                                    cursor: 'pointer',
                                    lineHeight: 1,
                                    padding: 0,
                                }}
                            >
                                ×
                            </button>
                        </div>

                        <div style={{ padding: '24px' }}>
                            <h3 style={{ color: '#004172', fontSize: '16px', fontWeight: 700, marginBottom: '12px' }}>Compliance notice</h3>
                            <div
                                style={{
                                    border: '1px solid #ddd',
                                    borderRadius: '6px',
                                    padding: '16px',
                                    maxHeight: '240px',
                                    overflowY: 'auto',
                                    fontSize: '14px',
                                    color: '#333',
                                    lineHeight: '1.6',
                                }}
                            >
                                <p style={{ marginBottom: '12px' }}>
                                    Access to CureBay's Applications and Websites ("Platform") is restricted to human users only. Any use of artificial intelligence systems, autonomous agents, bots, or automated software to create accounts, submit registrations, conduct independent research, collect data, generate content, or interact with the Platform in any capacity is strictly prohibited without prior written authorisation.
                                </p>
                                <p style={{ marginBottom: '12px' }}>
                                    Any account or activity determined to have been created or operated by an AI entity or automated system will be terminated immediately without notice.
                                </p>
                                <p>
                                    Any unsolicited security testing, unauthorised access, coercive communication, or threats of public disclosure - whether framed as responsible disclosure or otherwise - will not be entertained and will be treated as unlawful conduct subject to legal action.
                                </p>
                            </div>
                        </div>

                        <div style={{ padding: '0 24px 24px' }}>
                            <button
                                onClick={handleComplianceUnderstand}
                                style={{
                                    width: '100%',
                                    backgroundColor: '#004172',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '8px',
                                    padding: '12px',
                                    fontSize: '15px',
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                }}
                            >
                                I Understand
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <Sidebar
                style={{ width: '588px' }}
                visible={showConsentView}
                onHide={() => setShowConsentView(false)}
                position="right"
            >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '1rem', borderBottom: '1px solid #ccc' }}>
                    <div className="font-poppins text-base font-semibold leading-6 tracking-normal text-left">
                        Update Consent
                    </div>
                    <Button
                        icon="pi pi-times"
                        onClick={() => setShowConsentView(false)}
                        className="p-button-text p-button-danger p-button-sm"
                    />
                </div>
                {renderConsentContent()}
                <div className='mt-32'>
                    <button
                        className="w-32 h-9 bg-[#004172] text-white rounded-md w-full"
                        onClick={onConsentAgree}
                    >
                        Update
                    </button>
                </div>
            </Sidebar>

            <div className="flex-1 hidden lg:flex items-center justify-center">
                <div className="bg-[#004172] h-full w-full relative">
                    <img src={login1} alt="Login" className="w-full object-cover" />
                    <div className="absolute top-[237px] flex flex-col justify-between font-bold text-center text-white left-0 w-full bg-[#004172] rounded-t-full h-[60%]">
                        <div>
                            <div className='text-3xl'>Welcome Back</div>
                            <p className='text-lg mt-3 font-semibold'>Manage your services from here!</p>
                        </div>
                        <div>
                            <img src={login2} alt="Login" className="loginImage bottom-0 w-[70%] h-[50%]" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex-1 flex flex-col items-center justify-center rounded-s-3xl rounded- bg-white relative">
                <img src={loginLogo} alt='Login Design' className="absolute top-3 left-3 w-[30%]" />
                <div className="mb-0 text-center mt-14">
                    <p className="font-extrabold text-3xl font-medium">
                        {loginType === 'forget' ? 'Forgot Password' : 'Login'}
                    </p>
                    <p className="font-rubik font-medium mt-5 text-gray-800">
                        {loginType === 'forget' ? 'Please enter your valid credentials for get your password' : 'Please enter your valid credentials for logging in'}
                    </p>
                    <img src={loginDesign} alt='Login Design' className="mt-4 mx-auto" />
                </div>

                <div className="w-3/4 p-8 bg-white rounded">
                    <form className='flex flex-col items-center' onSubmit={handleFormSubmit}>
                        {loginType === 'email' && (
                            <>
                                <div className="mb-2 w-full text-left">
                                    <label htmlFor="email" className="text-sm font-semibold text-gray-800">
                                        Enter Your Email Id
                                    </label>
                                </div>
                                <div className="mb-4 w-full">
                                    <input
                                        name="userCode"
                                        type="text"
                                        id="userCode"
                                        placeholder='Enter Email'
                                        className="block px-4 w-full h-10 py-2 mt-2 text-purple-700 bg-white border rounded-md focus:border-purple-400 focus:ring-purple-300 focus:outline-none focus:ring focus:ring-opacity-40"
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="mb-2 w-full text-left">
                                    <label htmlFor="passWord" className="text-sm font-semibold text-gray-800">
                                        Enter Password
                                    </label>
                                </div>
                                <div className="mb-4 w-full relative">
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        id="passWord"
                                        name="passWord"
                                        placeholder="Enter your password"
                                        className="block w-full px-4 py-2 mt-2 h-10 text-purple-700 bg-white border rounded-md focus:border-purple-400 focus:ring-purple-300 focus:outline-none focus:ring focus:ring-opacity-40 pr-10"
                                        value={formData.passWord}
                                        onChange={handleChange}
                                    />
                                    <button
                                        type="button"
                                        className="absolute inset-y-0 right-0 flex items-center pr-2 cursor-pointer bg-transparent border-none"
                                        onClick={togglePasswordVisibility}
                                    >
                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                    </button>
                                </div>
                                <div className="flex justify-end mb-4">
                                    <button
                                        type="button"
                                        className="hover:underline focus:outline-none"
                                        onClick={() => handleLoginTypeChange('forget')}
                                    >
                                        Forgot Password?
                                    </button>
                                </div>
                            </>
                        )}

                        {loginType === 'mobile' && (
                            <>
                                <div className="mb-2 w-full text-left">
                                    <label htmlFor="email" className="text-sm font-semibold text-gray-800">
                                        Enter Your Mobile Number
                                    </label>
                                </div>
                                <div className="mb-4 w-full">
                                    <input
                                        name="userMobileNumber"
                                        type="text"
                                        id="userMobileNumber"
                                        placeholder='Enter Mobile Number'
                                        className="block w-full px-4 py-2 mt-2 text-purple-700 bg-white border rounded-md focus:border-purple-400 focus:ring-purple-300 focus:outline-none focus:ring focus:ring-opacity-40"
                                        onChange={handleChange}
                                    />
                                </div>
                                {showOtp && (
                                    <>
                                        <div className="mb-2 w-full text-left">
                                            <label htmlFor="userOTP" className="text-sm font-semibold text-gray-800">
                                                Enter OTP
                                            </label>
                                        </div>
                                        <div className="flex mb-4 w-full">
                                            {renderOTPInputs()}
                                        </div>
                                        <div className="flex justify-end">
                                            <button
                                                type="button"
                                                className="text-blue-500 hover:underline focus:outline-none"
                                                onClick={handleResendOTP}
                                                disabled={resendDisabled}
                                            >
                                                Resend OTP {resendDisabled ? `in ${seconds} seconds` : ''}
                                            </button>
                                        </div>
                                    </>
                                )}
                            </>
                        )}

                        {loginType === 'forget' && (
                            <>
                                <div className="mb-2 w-full text-left">
                                    <label htmlFor="email" className="text-sm font-semibold text-gray-800">
                                        Email Or Mobile Number
                                    </label>
                                </div>
                                <div className="mb-4 w-full">
                                    <input
                                        name="userMobileNumber"
                                        type="text"
                                        id="userMobileNumber"
                                        placeholder='Enter Mobile Number'
                                        className="block w-full px-4 py-2 mt-2 text-primary bg-white border rounded-md focus:border-purple-400 focus:ring-purple-300 focus:outline-none focus:ring focus:ring-opacity-40"
                                        onChange={handleChangeforget}
                                    />
                                </div>
                            </>
                        )}

                        {loginType !== 'forget' && (
                            <div className="mb-4 w-full">
                                <div
                                    style={{
                                        backgroundColor: '#f0f7ff',
                                        border: '1px solid #cce0f5',
                                        borderRadius: '8px',
                                        padding: '12px 14px',
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        gap: '10px',
                                        marginBottom: '10px',
                                    }}
                                >
                                    <span style={{ color: '#004172', fontSize: '18px', marginTop: '1px' }}>🛡️</span>
                                    <p style={{ fontSize: '13px', color: '#333', margin: 0, lineHeight: '1.5' }}>
                                        This platform is restricted to human users only. Use of AI systems, bots, or automated software is strictly prohibited.{' '}
                                        <button
                                            type="button"
                                            onClick={() => setShowCompliancePopup(true)}
                                            style={{
                                                background: 'transparent',
                                                border: 'none',
                                                color: '#004172',
                                                fontWeight: 600,
                                                cursor: 'pointer',
                                                padding: 0,
                                                textDecoration: 'underline',
                                                fontSize: '13px',
                                            }}
                                        >
                                            View Compliance →
                                        </button>
                                    </p>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                    <input
                                        type="checkbox"
                                        id="humanConfirm"
                                        checked={humanConfirmed}
                                        onChange={(e) => setHumanConfirmed(e.target.checked)}
                                        style={{ marginTop: '3px', cursor: 'pointer', accentColor: '#004172' }}
                                    />
                                    <label
                                        htmlFor="humanConfirm"
                                        style={{ fontSize: '13px', color: '#333', cursor: 'pointer', lineHeight: '1.5' }}
                                    >
                                        <span style={{ color: 'red' }}>*</span> I confirm I am a human user and agree to CureBay's Terms of Service, including the AI &amp; Automation Prohibition Policy
                                    </label>
                                </div>
                            </div>
                        )}

                        {!showSubmitOtp && loginType !== 'forget' && (
                            <div className="mb-4 w-full">
                                <button
                                    type="submit"
                                    className="w-full bg-primary h-10 hover:bg-blue-600 text-white text-lg font-medium py-2 rounded-lg transition duration-300 ease-in-out"
                                    disabled={loading || !humanConfirmed}
                                    style={{ opacity: !humanConfirmed ? 0.6 : 1, cursor: !humanConfirmed ? 'not-allowed' : 'pointer' }}
                                >
                                    {loading ? 'Logging in...' : 'Login'}
                                </button>
                            </div>
                        )}

                        {showSubmitOtp && loginType !== 'forget' && (
                            <div className="mb-4 w-full">
                                <button
                                    type="button"
                                    onClick={handleSubmitClick}
                                    className="w-full bg-blue-500 hover:bg-blue-600 text-white text-lg font-medium py-2 rounded-lg transition duration-300 ease-in-out"
                                    disabled={submitLoading || !humanConfirmed}
                                    style={{ opacity: !humanConfirmed ? 0.6 : 1, cursor: !humanConfirmed ? 'not-allowed' : 'pointer' }}
                                >
                                    {submitLoading ? 'Logging in...' : 'Submit'}
                                </button>
                            </div>
                        )}

                        {loginType === 'forget' && (
                            <div className="mb-4 w-full">
                                <button
                                    type="button"
                                    className="text-primary hover:underline focus:outline-none"
                                    onClick={() => handleLoginTypeChange('email')}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    onClick={forgetPassword}
                                    className="w-full mt-6 bg-primary hover:bg-blue-600 text-white text-lg font-medium py-2 rounded-lg transition duration-300 ease-in-out"
                                >
                                    Submit
                                </button>
                            </div>
                        )}

                        <div className="flex justify-between w-full">
                            {loginType === 'mobile' && (
                                <button
                                    type="button"
                                    className="text-blue-500 focus:outline-none"
                                    onClick={() => handleLoginTypeChange('email')}
                                >
                                    Login With User ID
                                </button>
                            )}
                        </div>
                    </form>
                </div>
            </div>

            <Modal open={termsView} onClose={() => setTermsView(false)}>
                <Box sx={{ ...style, width: 1000, height: 600 }}>
                    <div className='bg-white'>
                        <CardHeader
                            title={
                                <Typography variant="h6" style={{ fontSize: '18px', fontWeight: 500 }}>
                                    Terms of use
                                </Typography>
                            }
                            action={
                                <IconButton onClick={() => setTermsView(false)}>
                                    <CloseIcon />
                                </IconButton>
                            }
                            style={{ backgroundColor: '#f5f5f5', borderBottom: '1px solid #e0e0e0' }}
                        />
                        <Divider />
                        {consentVersionT && (
                            <div className="bg-white">
                                <iframe
                                    src={`${process.env.REACT_APP_IMAGE_URL}${consentVersionT?.consentFile}`}
                                    height="450px"
                                    width="900px"
                                    title="Terms and Conditions"
                                />
                            </div>
                        )}
                    </div>
                </Box>
            </Modal>

            <Modal open={privacyView} onClose={() => setPrivacyView(false)}>
                <Box sx={{ ...style, width: 1000, height: 600 }}>
                    <div className='bg-white'>
                        <CardHeader
                            title={
                                <Typography variant="h6" style={{ fontSize: '18px', fontWeight: 500 }}>
                                    Privacy Policy
                                </Typography>
                            }
                            action={
                                <IconButton onClick={() => setPrivacyView(false)}>
                                    <CloseIcon />
                                </IconButton>
                            }
                            style={{ backgroundColor: '#f5f5f5', borderBottom: '1px solid #e0e0e0' }}
                        />
                        <Divider />
                        {consentVersionP && (
                            <div className="bg-white">
                                <iframe
                                    src={`${process.env.REACT_APP_IMAGE_URL}${consentVersionP?.consentFile}`}
                                    height="450px"
                                    width="900px"
                                    title="Privacy Policy"
                                />
                            </div>
                        )}
                    </div>
                </Box>
            </Modal>
        </div>
    );
};

export default LoginPage;